import { SelectLang } from '@zhiyue/core';
import React from 'react';
import styles from './ShellLayout.module.less';

// 原生按钮的 Enter / Space 点击转交给平台旧版 span 入口，保留语言菜单与状态。
export default function HeaderLanguage() {
  return React.createElement(
    'button',
    {
      type: 'button',
      className: styles.action,
      'aria-label': '切换语言',
      onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
        if (event.target !== event.currentTarget) return;
        event.currentTarget
          .querySelector<HTMLElement>('.ant-dropdown-trigger')
          ?.click();
      },
    },
    React.createElement(SelectLang),
  );
}
